/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'

import { Route, Switch, Redirect } from 'react-router-dom'
import PropTypes from 'propTypes'

import ApplicationsMain from '../Applications/MainLazy'
import AwaitingKickOffMain from '../AwaitingKickOff/MainLazy'
import CandidateListESMain from '@/CandidateListES/MainLazy'
import FavouritesListMain from '../FavouritesList/MainLazy'
import HiringAnalyticsMain from '../HiringAnalytics/MainLazy'
import InterviewRequestsMain from '../InterviewRequests/MainLazy'
import IntegrationsMain from '../Integrations/MainLazy'
import PositionsDashboardMain from '../PositionsDashboard/MainLazy'
import DashboardMain from '../Dashboard/MainLazy'
import { companyStateRedirects } from './helpers/redirectHelpers'
import RecommendationsMain from '@/Recommendations/MainLazy'
import RecommendationsV2Main from '@/RecommendationsV2/MainLazy'
import EditCompanyProfileMain from '@/EditCompanyProfile/Main'

const NestedRoutes = ({ companyProps, companyDetails, rootRouteProps, mediaProps, userProps, refetchInitialState }) => {
  const handleRedirects = () => {
    const pathArray = rootRouteProps.location.pathname.split('/')
    const redirectPath = rootRouteProps.match.path
    const stateRedirects = companyStateRedirects({
      companyState: companyProps.companyState,
      acceptedTerms: companyProps.companyAcceptedTerms,
    })

    const redirectKey = pathArray.find(pathItem => stateRedirects.redirectMap.has(pathItem))

    if (!redirectKey) return null

    return <Redirect to={`${redirectPath}/${stateRedirects.redirectMap.get(redirectKey).to}`} />
  }

  return (
    <Switch>
      {handleRedirects()}

      <Route
        path={`${rootRouteProps.match.path}/profile`}
        render={routeProps => <EditCompanyProfileMain {...mediaProps} {...routeProps} />}
      />

      <Route
        path={`${rootRouteProps.match.path}/candidates`}
        render={routeProps => (
          <CandidateListESMain
            {...mediaProps}
            {...routeProps}
            hiringTeam={userProps.currentHiringTeam}
            companyState={companyProps.companyState}
            companyAcceptedTerms={companyProps.companyAcceptedTerms}
            companyId={companyProps.companyId}
            companyName={companyDetails.name}
            refetchInitialState={refetchInitialState}
          />
        )}
      />

      <Route
        path={`${rootRouteProps.match.path}/recommendations`}
        render={() => (
          <RecommendationsMain
            {...mediaProps}
            companyName={companyDetails.name}
            currentUser={userProps}
            companySlug={companyProps.companySlug}
            companyId={companyProps.companyId}
          />
        )}
      />

      <Route
        path={`${rootRouteProps.match.path}/recommendations-beta`}
        render={() => (
          <RecommendationsV2Main
            {...mediaProps}
            companyName={companyDetails.name}
            currentUser={userProps}
            companySlug={companyProps.companySlug}
            companyId={companyProps.companyId}
          />
        )}
      />

      <Route
        path={`${rootRouteProps.match.path}/applications`}
        render={routeProps => (
          <ApplicationsMain
            {...mediaProps}
            {...routeProps}
            companyId={companyProps.companyId}
            companyState={companyProps.companyState}
            companySlug={companyProps.companySlug}
          />
        )}
      />

      <Route
        path={`${rootRouteProps.match.path}/dashboard`}
        render={routeProps => (
          <DashboardMain
            {...mediaProps}
            {...routeProps}
            companyId={companyProps.companyId}
            companySlug={companyProps.companySlug}
            companyActiveSubscription={companyProps.companyActiveSubscription}
          />
        )}
      />

      <Route
        path={`${rootRouteProps.match.path}/shortlist`}
        render={routeProps => <FavouritesListMain {...mediaProps} {...routeProps} companySlug={companyProps.companySlug} />}
      />
      <Route
        path={`${rootRouteProps.match.path}/interview_requests`}
        render={routeProps => <InterviewRequestsMain {...mediaProps} {...routeProps} />}
      />
      <Route
        path={`${rootRouteProps.match.path}/analytics`}
        render={routeProps => (
          <HiringAnalyticsMain {...mediaProps} {...routeProps} companyLiveOrDormant={companyProps.companyLiveOrDormant} />
        )}
      />
      <Route path={`${rootRouteProps.match.path}/welcome`} render={routeProps => <AwaitingKickOffMain {...mediaProps} {...routeProps} />} />

      <Route
        path={`${rootRouteProps.match.path}/positions`}
        render={routeProps => (
          <PositionsDashboardMain
            {...mediaProps}
            {...routeProps}
            companyId={companyProps.companyId}
            companyState={companyProps.companyState}
            companyPreLive={companyProps.companyPreLive}
          />
        )}
      />

      <Route path={`${rootRouteProps.match.path}/integration_partners`}>
        <IntegrationsMain
          {...mediaProps}
          companyId={companyProps.companyId}
          companySlug={companyProps.companySlug}
          userRole={userProps.userRole}
          emailPreferencesAccessTokenKey={userProps.emailPreferencesAccessTokenKey}
        />
      </Route>
    </Switch>
  )
}
const { shape, string, func } = PropTypes
NestedRoutes.propTypes = {
  companyDetails: shape({
    id: string,
    name: string,
    created_at: string,
  }),
  companyProps: shape({}),
  mediaProps: shape({}),
  userProps: shape({}),
  rootRouteProps: shape({}),
  refetchInitialState: func,
}

export default NestedRoutes
